<app-open-registration *ngIf="showOpenRegistration$ | async; else registrationList"></app-open-registration>

<ng-template #registrationList>
  <app-registration-list></app-registration-list>
</ng-template>
